<div class="super-table" [style.--super-table-row-height.px]="rowHeight">
  <div class="table-toolbar" *ngIf="controls.length > 0 || tableActions.length > 0 || footerActions.length > 0">
    <div class="toolbar-controls" *ngIf="controls.length > 0">
      <ng-container *ngFor="let control of controls">
        <label class="control-item" *ngIf="(control.type || 'select') === 'select'">
          <span class="control-label" *ngIf="control.label">{{ control.label }}</span>
          <select class="control-select" [value]="controlValues[control.key]"
            (change)="onControlValueChange(control, $event)">
            <option *ngFor="let option of resolveControlOptions(control)" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </label>

        <button *ngIf="(control.type || 'select') !== 'select'" type="button" class="control-button"
          [ngClass]="control.className" (click)="onControlClick(control, $event)">
          {{ control.label || control.key }}
        </button>
      </ng-container>
    </div>

    <div class="toolbar-actions" *ngIf="tableActions.length > 0 || footerActions.length > 0">
      <button *ngFor="let action of tableActions" type="button" class="table-action" [ngClass]="action.className"
        [disabled]="isTableActionBusy(action)" (click)="onTableAction(action, $event)">
        {{ action.label }}
      </button>

      <button *ngFor="let action of footerActions" type="button" class="table-action footer-action"
        [ngClass]="action.className" [disabled]="isTableActionBusy(action)" (click)="onTableAction(action, $event)">
        {{ action.label }}
      </button>
    </div>
  </div>

  <div class="table-shell">
    <div class="table-state" *ngIf="loading">
      <mat-spinner diameter="34"></mat-spinner>
    </div>

    <div class="table-state error" *ngIf="!loading && errorMessage">
      {{ errorMessage }}
    </div>

    <div class="table-state" *ngIf="!loading && !errorMessage && flatRows.length === 0">
      {{ emptyStateMessage }}
    </div>

    <div class="criteria-band" *ngIf="!loading && !errorMessage && flatRows.length > 0 && showCriteriaBand" 
      [style.width.px]="criteriaBandWidthPx"
      [style.height.px]="criteriaBandHeightPx" 
      [style.left.px]="0"
      [style.top.px]="getHeaderStackHeight()">
      <span>{{ criteriaBandLabel }}</span>
    </div>

    <div class="table-scroll" *ngIf="!loading && !errorMessage && flatRows.length > 0" [style.max-height]="tableHeight"
      [style.margin-left.px]="showCriteriaBand ? criteriaBandWidthPx : 0"
      [style.width]="showCriteriaBand ? 'calc(100% - ' + criteriaBandWidthPx + 'px)' : '100%'">
      
      <table class="unified-table" [style.width]="tableMinWidth" [style.min-width]="tableMinWidth" #tableRoot>
        <colgroup>
          <col *ngFor="let column of visibleColumns; trackBy: trackByColumn" [style.width]="column.widthCss"
            [style.min-width]="column.minWidthCss" />
        </colgroup>
        <thead>
          <!-- Weightage row: shows weight values from API per column group -->
          <tr *ngIf="hasWeightageRow" class="weightage-row">
            <ng-container *ngFor="let cell of weightageCells; let i = index; trackBy: trackByWeightageCell">
              <th class="weightage-cell"
                [attr.colspan]="cell.colspan"
                [ngStyle]="getWeightageCellStyle(cell)"
                [class.frozen-column]="cell.frozen">
                <ng-container *ngIf="i === 0">
                  <span class="weightage-label">Weightage →</span>
                </ng-container>
                <ng-container *ngIf="i !== 0">
                  <span class="weightage-value">{{ cell.value }}</span>
                </ng-container>
              </th>
            </ng-container>
          </tr>
          <ng-container *ngFor="let headerRow of headerRows; let headerRowIndex = index">
            <tr>
              <th *ngFor="let cell of headerRow; trackBy: trackByHeaderCell" [attr.colspan]="cell.colspan"
                [attr.rowspan]="cell.rowspan" [ngStyle]="getHeaderCellStyle(cell, headerRowIndex)"
                [ngClass]="cell.className" [class.sortable]="cell.sortable" [class.frozen-column]="cell.frozen"
                [class.frozen-column-edge]="isLastFrozenRenderColumn(cell.column)"
                [class.header-group-cell]="!cell.column" [class.header-placeholder-cell]="cell.placeholder"
                [class.serial-header-cell]="cell.column?.type === 'serial' && !cell.placeholder"
                (click)="onHeaderCellClick(cell, $event)">
                <ng-container *ngIf="cell.placeholder; else headerContent"></ng-container>
                <ng-template #headerContent>
                  <ng-container *ngIf="cell.column?.type === 'serial'; else defaultHeaderLabel">
                    <div class="serial-header" (click)="$event.stopPropagation()">
                      <input class="serial-checkbox" type="checkbox" [checked]="isAllRowsSelected($any(cell.column))"
                        [indeterminate]="isSomeRowsSelected($any(cell.column))" (click)="$event.stopPropagation()"
                        (change)="onSelectAllRowsChange($any(cell.column), $event)" />
                      <span class="serial-header-label">{{ cell.label }}</span>
                    </div>
                  </ng-container>
                  <ng-template #defaultHeaderLabel>
                    <span>{{ cell.label }}</span>
                  </ng-template>
                </ng-template>
              </th>
            </tr>
          </ng-container>
        </thead>

        <tbody>
          <tr *ngFor="let row of flatRows; let rowIndex = index; trackBy: trackByRow"
            [ngClass]="getRowClass(row, rowIndex)">
            <ng-container *ngFor="let column of visibleColumns; let columnIndex = index; trackBy: trackByColumn">
            <td *ngIf="!shouldSkipScalePlaceholderCell(rowIndex, column)"
              [attr.rowspan]="isScalePlaceholderBlockCell(rowIndex, column) ? getScalePlaceholderRowspan(rowIndex) : null"
              [attr.colspan]="isScalePlaceholderBlockCell(rowIndex, column) ? getScalePlaceholderColspan() : null"
              [ngStyle]="getBodyCellStyle(row, rowIndex, column, columnIndex)"
              [ngClass]="getCellClass(row, rowIndex, column, columnIndex) + (isScalePlaceholderBlockCell(rowIndex, column) ? ' scale-placeholder-cell' : '')"
              [attr.title]="isScalePlaceholderBlockCell(rowIndex, column) ? null : (getTooltipText(row.source, column) || null)"
              (click)="!isScalePlaceholderBlockCell(rowIndex, column) && handleCellClick(row, column)">
              <ng-container *ngIf="isScalePlaceholderBlockCell(rowIndex, column); else defaultBodyCell">
                <div class="cell-content" style="justify-content: center; text-align: center;">
                  <span class="cell-value">{{ getScalePlaceholderLabel() }}</span>
                </div>
              </ng-container>

              <ng-template #defaultBodyCell>
              <div class="cell-content"
                [style.padding-left]="showToggleInColumn(column, columnIndex) ? getIndentPadding(row.depth) : ''"
                [style.justify-content]="column.align === 'center' ? 'center' : (column.align === 'right' ? 'flex-end' : 'flex-start')"
                [style.text-align]="column.align || 'left'">
                <button *ngIf="showToggleInColumn(column, columnIndex) && row.hasChildren" class="toggle-btn"
                  type="button" (click)="toggleRow(row, $event)">
                  {{ row.expanded ? '-' : '+' }}
                </button>

                <ng-container [ngSwitch]="resolveCellType(row.source, column)">
                  <div *ngSwitchCase="'serial'" class="serial-cell" (click)="$event.stopPropagation()">
                    <input class="serial-checkbox" type="checkbox" [checked]="isRowSelected(row, column)"
                      (click)="$event.stopPropagation()" (change)="onSerialSelectionChange(row, column, $event)" />
                    <span class="serial-index">{{ getRowSerial(rowIndex) }}</span>
                  </div>

                  <textarea *ngSwitchCase="'textarea'" class="cell-input cell-textarea"
                    [value]="getCellValue(row.source, column) ?? ''" [placeholder]="getPlaceholder(row.source, column)"
                    [style.text-align]="column.align || 'left'"
                    [disabled]="!isCellEditable(row.source, column)" (click)="$event.stopPropagation()"
                    (input)="onTextInput(row, column, $event)"></textarea>

                  <select *ngSwitchCase="'select'" class="cell-input" [value]="getCellValue(row.source, column)"
                    [style.text-align]="column.align || 'left'"
                    [disabled]="!isCellEditable(row.source, column)" (click)="$event.stopPropagation()"
                    (change)="onSelectChange(row, column, $event)">
                    <option *ngFor="let option of resolveOptions(row.source, column)" [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>

                  <label *ngSwitchCase="'checkbox'" class="checkbox-editor" (click)="$event.stopPropagation()">
                    <input type="checkbox" [checked]="!!getCellValue(row.source, column)"
                      [disabled]="!isCellEditable(row.source, column)"
                      (change)="onCheckboxChange(row, column, $event)" />
                    <span>{{ getDisplayValue(row.source, column) }}</span>
                  </label>

                  <div *ngSwitchCase="'action'" class="action-group" (click)="$event.stopPropagation()">
                    <button *ngFor="let action of getCellActions(row.source, column)" type="button" class="action-btn"
                      [ngClass]="action.className" [disabled]="isActionDisabled(action, row.source)"
                      [hidden]="!isActionVisible(action, row.source)"
                      (click)="onCellAction(action, row, column, $event)">
                      {{ action.label }}
                    </button>
                  </div>

                  <a *ngSwitchCase="'link'" href="#" class="cell-link" (click)="onCellNavigate(row, column, $event)">
                    {{ getDisplayValue(row.source, column) }}
                  </a>

                  <div *ngSwitchCase="'image'" class="cell-image-wrap" (click)="$event.stopPropagation()">
                    <img *ngIf="resolveImageSource(getCellValue(row.source, column)) as imageSrc; else noImage"
                      class="cell-image" [src]="imageSrc" [alt]="column.label || column.key" loading="lazy" />
                    <ng-template #noImage>
                      <span class="cell-value">—</span>
                    </ng-template>
                  </div>

                  <div *ngSwitchCase="'chart'" class="chart-cell" (click)="$event.stopPropagation()">
                    <ng-container *ngIf="resolveChartConfig(row.source, column) as chart">
                      <ng-container *ngIf="isInlineMiniChart(chart); else dynamicCellChart">
                        <div *ngIf="getChartType(chart) === 'progress'" class="mini-progress">
                          <span class="mini-progress-fill" [style.width.%]="getProgressPercent(chart)"
                            [style.background]="getProgressColor(chart)"></span>
                        </div>
                      </ng-container>

                      <ng-template #dynamicCellChart>
                        <div class="dynamic-widget-host">
                          <app-super-dynamic-chart-host
                            [target]="getCellDynamicChartTarget(row, column, chart)"></app-super-dynamic-chart-host>
                        </div>
                      </ng-template>
                    </ng-container>
                  </div>

                  <ng-container *ngSwitchDefault>
                    <input *ngIf="isCellEditable(row.source, column)" class="cell-input"
                      [type]="getInputType(row.source, column)" [value]="getCellValue(row.source, column) ?? ''"
                      [placeholder]="getPlaceholder(row.source, column)" [style.text-align]="column.align || 'left'"
                      (click)="$event.stopPropagation()"
                      (input)="onTextInput(row, column, $event)" />

                    <span *ngIf="!isCellEditable(row.source, column)" class="cell-value">
                      {{ getDisplayValue(row.source, column) }}
                    </span>
                  </ng-container>
                </ng-container>

                <button *ngIf="hasPopup(row.source, column)" class="popup-trigger" type="button"
                  (click)="togglePopup(row, column, $event)">
                  i
                </button>
              </div>
              </ng-template>
            </td>
            </ng-container>
          </tr>

          <tr *ngIf="showBottomScoreRow" class="score-row">
            <td class="score-label-cell" [attr.colspan]="bottomScoreLabelColspan">
              <div class="cell-content" style="justify-content: center; text-align: center;">
                <span class="cell-value">{{ bottomScoreLabel }}</span>
              </div>
            </td>

            <td *ngFor="let value of bottomScoreValues" class="score-value-cell">
              <div class="cell-content" style="justify-content: center; text-align: center;">
                <span class="cell-value">{{ value }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="bottom-actions" *ngIf="bottomActions.length > 0">
    <button *ngFor="let action of bottomActions" type="button" class="table-action bottom-action"
      [ngClass]="action.className" [disabled]="isTableActionBusy(action)" (click)="onTableAction(action, $event)">
      {{ action.label }}
    </button>
  </div>

  <div class="super-table-popup" *ngIf="activePopup" [ngStyle]="getPopupStyle()" (click)="onPopupPanelClick($event)">
    <div class="popup-header">
      <strong>{{ activePopup.title }}</strong>
      <button type="button" class="popup-close" (click)="closePopup()">×</button>
    </div>

    <div class="popup-body" *ngIf="activePopup.loading">
      Loading...
    </div>

    <div class="popup-body" *ngIf="!activePopup.loading && activePopup.error">
      {{ activePopup.error }}
    </div>

    <div class="popup-body" *ngIf="!activePopup.loading && !activePopup.error && activePopup.type === 'text'">
      {{ activePopup.text }}
    </div>

    <div class="popup-body" *ngIf="!activePopup.loading && !activePopup.error && activePopup.type === 'table'">
      <table class="popup-table" *ngIf="activePopup.tableRows.length > 0; else emptyPopupTable">
        <thead>
          <tr>
            <th *ngFor="let column of activePopup.tableColumns">{{ column.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of activePopup.tableRows">
            <td *ngFor="let column of activePopup.tableColumns">{{ row[column.key] }}</td>
          </tr>
        </tbody>
      </table>
      <ng-template #emptyPopupTable>No records available.</ng-template>
    </div>

    <div class="popup-body" *ngIf="!activePopup.loading && !activePopup.error && activePopup.type === 'chart'">
      <ng-container *ngIf="getPopupChart() as chart">
        <ng-container *ngIf="isInlineMiniChart(chart); else dynamicPopupChart">
          <div *ngIf="getChartType(chart) === 'progress'" class="mini-progress popup-progress">
            <span class="mini-progress-fill" [style.width.%]="getProgressPercent(chart)"
              [style.background]="getProgressColor(chart)"></span>
          </div>
        </ng-container>

        <ng-template #dynamicPopupChart>
          <div class="dynamic-widget-host popup-widget-host">
            <app-super-dynamic-chart-host [target]="getPopupDynamicChartTarget(chart)"></app-super-dynamic-chart-host>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
